import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addBrand = async (token, data) => {
  const url = `${BASE_URL}/products/brands-details/`;

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name);
    } else if (data[key] === null) {
    } else {
      formData.append(key, data[key]);
    }
  });

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, formData, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const getAllBrands = async (token, params = {}) => {
  const url = `${BASE_URL}/products/brands-details/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getBrand = async (token, brandId) => {
  const url = `${BASE_URL}/products/brands-details/${brandId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateBrand = async (token, data, brandId) => {
  const url = `${BASE_URL}/products/brands-details/${brandId}/`;

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name);
    } else if (data[key] === null) {
    } else {
      formData.append(key, data[key]);
    }
  });

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.patch(url, formData, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteBrand = async (token, brandId) => {
  const url = `${BASE_URL}/products/brands-details/${brandId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
